<template>
  <div>
    <BCard no-body>
      <table>
        <thead>
          <tr>
            <th
              colspan="7"
              class="p-2 text-center"
            >
              <h5>March 2 - 8, 2025</h5>
            </th>
          </tr>
          <tr>
            <th class="p-2 text-center">
              S
            </th>
            <th class="p-2 text-center">
              M
            </th>
            <th class="p-2 text-center">
              T
            </th>
            <th class="p-2 text-center">
              W
            </th>
            <th class="p-2 text-center">
              T
            </th>
            <th class="p-2 text-center">
              F
            </th>
            <th class="p-2 text-center">
              S
            </th>
          </tr>
        </thead>
        <tbody>
          <tr v-b-scrollspy:nav-scroller>
            <td>
              <a
                href="#one"
                target="_self"
                class="nav-link p-2 pb-4 text-center"
              >
                <div>
                  <b>1</b>
                </div>
              </a>
            </td>
            <td>
              <a
                href="#two"
                target="_self"
                class="nav-link p-2 pb-4 text-center"
              >
                <div>
                  <b>2</b>
                </div>
              </a>
            </td>
            <td>
              <a
                href="#three"
                target="_self"
                class="nav-link p-2 pb-4 text-center"
              >
                <div>
                  <b>3</b>
                </div>
              </a>
            </td>
            <td>
              <a
                href="#four"
                target="_self"
                class="nav-link p-2 pb-4 text-center"
              >
                <div>
                  <b>4</b>
                </div>
              </a>
            </td>
            <td>
              <a
                href="#five"
                target="_self"
                class="nav-link p-2 pb-4 text-center"
              >
                <div>
                  <b>5</b>
                </div>
              </a>
            </td>
            <td>
              <a
                href="#six"
                target="_self"
                class="nav-link p-2 pb-4 text-center"
              >
                <div>
                  <b>6</b>
                </div>
              </a>
            </td>
            <td>
              <a
                href="#seven"
                target="_self"
                class="nav-link p-2 pb-4 text-center"
              >
                <div>
                  <b>7</b>
                </div>
              </a>
            </td>
          </tr>
        </tbody>
      </table>

      <BCardBody
        id="nav-scroller"
        ref="content"
        style="position:relative; height:300px; overflow-y:scroll;"
      >
        <p>{{ text }}</p>
        <!--
        <h4 id="one">
          @fat
        </h4>
        <p v-for="i in 3">
          {{ text }}
        </p>
        <h4 id="two">
          @mdo
        </h4>
        <p v-for="i in 3">
          {{ text }}
        </p>
        <h4 id="three">
          one
        </h4>
        <p v-for="i in 2">
          {{ text }}
        </p>
        <h4 id="four">
          two
        </h4>
        <p>{{ text }}</p>
        <h4 id="five">
          three
        </h4>
        <p v-for="i in 2">
          {{ text }}
        </p>
        <h4 id="six">
          @pi0
        </h4>
        <p v-for="i in 3">
          {{ text }}
        </p> -->
      </BCardBody>
    </BCard>
  </div>
</template>
<script>
export default {
  data () {
    return {
      text: `
          Quis magna Lorem anim amet ipsum do mollit sit cillum voluptate ex nulla
          tempor. Laborum consequat non elit enim exercitation cillum aliqua
          consequat id aliqua. Esse ex consectetur mollit voluptate est in duis
          laboris ad sit ipsum anim Lorem. Incididunt veniam velit elit elit veniam
          Lorem aliqua quis ullamco deserunt sit enim elit aliqua esse irure. Laborum
          nisi sit est tempor laborum mollit labore officia laborum excepteur
          commodo non commodo dolor excepteur commodo. Ipsum fugiat ex est consectetur
          ipsum commodo tempor sunt in proident.
        `
    }
  },
  methods: {
    // Convenience method to scroll a heading into view.
    // Not required for scrollspy to work
    scrollIntoView (event) {
      event.preventDefault()
      const href = event.target.getAttribute('href')
      const el = href ? document.querySelector(href) : null
      if (el) {
        this.$refs.content.scrollTop = el.offsetTop
      }
    }
  }
}
</script>
<style>
  td>a.nav-link.active {
    background-color: aqua !important;
  }
  .fc .fc-daygrid-day-frame {
    min-height: 300px !important;
  }
</style>
